import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import CaseReviewDetails from "../components/CaseReviewDetails";
import CaseReviewNavbar from "../components/CaseReviewNavbar";
import FooterSection from "../components/FooterSection";



function DoctorPortal({ name }) {
  // Generate a unique patient ID when component loads
  const generatePatientId = () => `PAT-${Date.now()}`;

  const [id, setId] = useState(generatePatientId()); // Initialize with a generated ID
  const [patientname, setName] = useState("");
  const [age, setAge] = useState("");
  const [culturalBackground, setCulturalBackground] = useState("");
  const [positiveWords, setPositiveWords] = useState([]);
  const API_BASE_URL = process.env.NODE_ENV === "production"
  ? process.env.REACT_APP_PROD_API_BASE_URL
  : process.env.REACT_APP_DEV_API_BASE_URL;
  const navigate = useNavigate();
  const casereview = () => {
 {/*   navigate("/login");  */}
   navigate("/student_form");
 {/*   navigate("/temp_test");  */}
  };
  const highlightPositiveWords = (text) => {
    if (!text) return text;
    return text.split(" ").map((word, index) => {
      const wordLowerCase = word.toLowerCase();
      const isPositive = positiveWords.includes(wordLowerCase);

      return isPositive ? (
        <span key={index} className="highlight">
          {word}{" "}
        </span>
      ) : (
        <span key={index}>{word} </span>
      );
    });
  };

  return (

      <div className="flex flex-col min-h-screen">

      <div class="min-h-screen font-sans text-gray-800">
      <Navbar name={name} />
        <div class="w-full">
          {/* <!-- Hero Section --> */}
          <section class="bg-[#1D3A73] text-white px-6 pt-10 flex flex-col md:flex-row items-center justify-between">
            <div class="md:w-2/3 ml-12">
              <h1 class="text-3xl font-bold mb-2">You Speak with Care,<br/> But Is That What Patients Hear?</h1>
              <p class="text-sm mb-4">
                Even well-meaning language can unintentionally harm.<br/>
                take our AI-powered mock consults to gauge your Empathy Quotient, try this:
              </p>
              <button onClick={casereview} className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold text-lg px-6 py-3 rounded-xl shadow-lg transform transition duration-200 hover:scale-105 mb-4">
                Go to Mock Cases
              </button>
            </div>
            <div class="md:w-1/3 mt-6 md:mt-0">
              <img src="./layer_18.png" alt="Doctor" class="w-full max-w-xs mx-auto" />
            </div>
          </section>

          {/* <!-- What is ConversationAlly Section --> */}
          <section class="bg-white px-6 py-10 text-center">
            <h2 class="text-2xl font-semibold mb-4">What is ConversationAlly?</h2>
            <p class="max-w-3xl mx-auto text-gray-700 mb-6">
              Grounded in global behavioral science frameworks, ConversationAlly is a patented solution designed to address a persistent, overlooked barrier in chronic care: the unintentional use of harmful or alienating language, especially in diabetes, obesity, and women’s health.
            </p>
            <div class="flex flex-col sm:flex-row justify-center gap-8 mt-6">
              <div class="flex flex-col items-center">
                <img src="./layer_12.png" alt="Continuity" class="h-10 mb-2" />
                <p class="text-sm">Continuity of Therapy</p>
              </div>
              <div class="flex flex-col items-center">
                <img src="./layer_13.png" alt="Trust" class="h-10 mb-2" />
                <p class="text-sm">Trust Building</p>
              </div>
              <div class="flex flex-col items-center">
                <img src="./layer_14.png" alt="Output" class="h-10 mb-2" />
                <p class="text-sm">Healthy Outputs</p>
              </div>
            </div>
          </section>

         {/* <!-- Why This Matters Section (Updated) --> */}
          <section className="px-6 py-12 text-left">
            <div className="bg-[#FBF6E3] px-6 py-12 max-w-6xl mx-auto">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#1D3A73] mb-4">
                Why this matters?
              </h2>
              <p className="text-[#333] text-base mb-10 max-w-3xl">
                You have spent years mastering the science. But sometimes, patients remember the words more than the treatment.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
                {/* Quote 1 */}
                <div className="flex items-start space-x-4">
                  <img src="./layer_4.png" alt="quote icon" className="w-8 h-8 mt-1" />
                  <div>
                    <p className="text-[#333] text-sm sm:text-base">
                      “When my doctor said I was non-compliant, I just shut down.”
                    </p>
                    <p className="text-sm italic text-[#222] mt-2">— Person with Type 2 Diabetes</p>
                  </div>
                </div>

                {/* Quote 2 */}
                <div className="flex items-start space-x-4">
                  <img src="./layer_5.png" alt="quote icon" className="w-8 h-8 mt-1" />
                  <div>
                    <p className="text-[#333] text-sm sm:text-base">
                      “They called me morbidly obese. That word stayed with me longer than any prescription.”
                    </p>
                    <p className="text-sm italic text-[#222] mt-2">— Person living with obesity</p>
                  </div>
                </div>
              </div>
            </div>
          </section>


          <section class="px-6 py-10 bg-white text-center relative">

            {/* <!-- Yellow Banner --> */}
            <div class="bg-[#FFA500] px-6 py-6 w-full text-left text-white relative z-0">
              <div class="max-w-6xl mx-auto">
                <h3 class="text-xl font-bold mb-1">Here’s what you can try today:</h3>
                <p class="text-base">
                  Start with a simple test. <br />
                  <span>Upload your voice consult or try a mock case.</span>
                </p>
              </div>
            </div>

            {/* <!-- Floating Cards --> */}
            <div class="flex flex-wrap justify-end gap-6 mt-[-155px] mr-[50px] relative z-10">
              {/* <!-- Card 1 --> */}
              <div class="bg-[#FFF9ED] p-4 w-[150px] rounded-lg shadow text-sm text-black text-center">
                <img src="./layer_26.png" alt="Step 1" class="h-10 mx-auto mb-2" />
                <p>A transcript with flagged stigmatizing terms</p>
              </div>

              {/* <!-- Card 2 --> */}
              <div class="bg-[#FFF9ED] p-4 w-[150px] rounded-lg shadow text-sm text-black text-center">
                <img src="./layer_27.png" alt="Step 2" class="h-10 mx-auto mb-2" />
                <p>Person-centered alternatives you can start using</p>
              </div>

              {/* <!-- Card 3 --> */}
              <div class="bg-[#FFF9ED] p-4 w-[150px] rounded-lg shadow text-sm text-black text-center">
                <img src="./layer_28.png" alt="Step 3" class="h-10 mx-auto mb-2" />
                <p>A tone check and empathy score based on behavioral research</p>
              </div>
            </div>

            {/* <!-- CTA Button --> */}
            <div class="mt-10">
              <button onClick={casereview} class="px-6 py-2 bg-[#1D3A73] text-white rounded shadow text-base font-semibold">
                Go to Mock Cases
              </button>
              <p class="text-sm text-gray-600 mt-2">
                Check if your words carry unintended bias or stigma.
              </p>
            </div>
          </section>


          {/* <!-- Final Section --> */}
          <section class="bg-[#1D3A73] text-white text-center py-10 px-4">
            <h2 class="text-3xl font-bold mb-2">Want more?</h2>
            <p class="text-base mb-8">
              After your first trial, explore the full <span class="text-yellow-400 font-semibold">ConversationAlly</span> platform:
            </p>

            <div class="flex flex-col md:flex-row justify-center items-center gap-6 max-w-5xl mx-auto">
              {/* <!-- Card 1 --> */}
              <div class="bg-[#1D3A73] border border-white rounded-3xl px-6 py-6 flex flex-col items-center w-[280px] text-white">
                <img src="./layer_9.png" class="h-10 mb-3" alt="Feedback" />
                <p class="text-lg font-normal">Longitudinal feedback</p>
              </div>

              {/* <!-- Card 2 --> */}
              <div class="bg-[#1D3A73] border border-white rounded-3xl px-6 py-6 flex flex-col items-center w-[280px] text-white">
                <img src="./layer_10.png" class="h-10 mb-3" alt="Languages" />
                <p class="text-lg font-normal">Multi-language cue libraries</p>
              </div>

              {/* <!-- Card 3 --> */}
              <div class="bg-[#1D3A73] border border-white rounded-3xl px-6 py-6 flex flex-col items-center w-[280px] text-white">
                <img src="./layer_11.png" class="h-10 mb-3" alt="Reports" />
                <p class="text-lg font-normal">Custom reports for clinics</p>
              </div>
            </div>
          </section>


          {/* <!-- Footer --> */}
          <FooterSection />
        </div>

      </div>

      </div>
  );
}

export default DoctorPortal;


